module.exports = __webpack_public_path__ + "a81e99ea994bd8b53435eac8d3709c33.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/heiko-behrens.jpg
 ** module id = 411
 ** module chunks = 0
 **/